import { useEffect, useMemo, useState } from "react";

import Joi from "joi-browser";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import { Heading } from "V2.0/common/heading";
import Form from "V2.0/components/Form";
import customSip from "V2.0/images/customSip.svg";

const buttonInfo = {
  label: "Connect Custom SIP",
  style: "entire-width",
};

const template = [
  {
    name: "sipAddress",
    type: "text",
    label: "SIP Address *",
  },
  {
    name: "authUsername",
    type: "text",
    label: "Auth Username",
  },
  {
    name: "authPassword",
    type: "password",
    label: "Auth Password",
  },
  {
    name: "originationIP",
    type: "text",
    label: "Origination IP *",
  },
  {
    name: "phoneNumbers",
    label: "Phone Numbers *",
    type: "inputFieldList",
    addLabel: "+ Add Phone Number",
    addPlaceholder: "",
  },
];

const schema = {
  sipAddress: Joi.string().required().label("SIP Address"),
  authUsername: Joi.string().allow(null, "").label("Auth Username"),
  authPassword: Joi.string().allow(null, "").label("Auth Password"),
  originationIP: Joi.string().required().label("Origination IP"),
  phoneNumbers: Joi.array()
    .items(Joi.string().regex(/^[a-zA-Z0-9+]+$/))
    .min(1)
    .required()
    .label("Phone Numbers"),
};

export default function CustomSIPForm(props) {
  const {
    customSipSettings,
    workspaceId,
    updateCustomSipSettings,
    isViewOnly,
  } = props;

  const [inputField, setInputField] = useState({
    sipAddress: "",
    authUsername: "",
    authPassword: "",
    originationIP: "",
    phoneNumbers: [],
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (customSipSettings) {
      setInputField({
        sipAddress: customSipSettings?.sipAddress,
        authUsername: customSipSettings?.authUsername,
        authPassword: customSipSettings?.authPassword,
        originationIP: customSipSettings?.originationIP,
        phoneNumbers: customSipSettings?.phoneNumbers,
      });
    }
  }, [customSipSettings]);

  const updatedTemplate = useMemo(() => {
    if (!isViewOnly) {
      return template;
    }

    return template.map((field) => {
      return {
        ...field,
        disabled: isViewOnly,
      };
    });
  }, [isViewOnly]);

  const updatedButtonInfo = !isViewOnly ? buttonInfo : {};

  async function handleSave(data) {
    const payload = {
      telephonySettings: {
        telephonyProvider: "livekit",
        livekitSettings: data,
      },
    };

    const lifecycleCbs = {
      init: () => {
        setLoading(true);
        message.loading("Connecting Custom SIP");
      },
      success: () => {
        message.destroy();
        message.success("Custom SIP Connected");
        setLoading(false);
      },
      error: (e) => {
        message.destroy();
        setLoading(false);
        showErrorToast(e, "Failed to connect Custom SIP");
      },
    };

    updateCustomSipSettings(payload, workspaceId, lifecycleCbs);
  }

  return (
    <div className="border rounded-lg p-8">
      <div className="flex gap-x-2 items-center">
        <img
          src={customSip}
          width={50}
        />
        <Heading>Connect Custom SIP</Heading>
      </div>
      <Form
        key={JSON.stringify(inputField)}
        errorMessage={{}}
        inputField={inputField}
        template={updatedTemplate}
        schema={schema}
        buttonInfo={updatedButtonInfo}
        onSubmit={handleSave}
        loading={loading}
        setLoading={setLoading}
      />
    </div>
  );
}
